import { Injectable, OnDestroy } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class AwardsService implements OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();
    private _CurrentAwardsSub: BehaviorSubject<AwardProgramInfo> = new BehaviorSubject<AwardProgramInfo>(null);

    // #region Getters and Setters

    public get CurrentAwards() {
        return this._CurrentAwardsSub.value;
    }

    public set CurrentAwards(value: AwardProgramInfo) {
        if (value !== this._CurrentAwardsSub.value) {
            this._CurrentAwardsSub.next(value);
        }
    }

    public get CurrentAwardsSub() {
        return this._CurrentAwardsSub;
    }

    // #endregion

    ngOnDestroy() {
        this._subrelease.next(); this._subrelease.complete();
    }
}

// #region Custom Classes

// #region Award Program Info Class

export class AwardProgramInfo {
    AwardID: number;
    ShortName: string;
    BannerName: string;
    Description: string;
    LoginWelcome: string;
    URLPath: string;
    IsJudged: boolean;
    HasRSVP: boolean;
}

// #endregion

// #endregion
